import News from "components/News";

export default function NewsAdmin() {
  return (
    <>
      <News showFilterCategory={true} />
    </>
  );
}
